import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WaterDropIcon from '@mui/icons-material/WaterDrop';

const IrrigationInsightCard = ({ date, id }) => {
  const { t } = useTranslation();
  return (
    <Box
      id={id}
      sx={{
        my: 2,
        p: 0,
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
        border: '1px solid #e0e0e0',
        '@media print': {
          margin: '2mm 0',
          boxShadow: 'none',
          border: '0.1mm solid #e0e0e0',
          pageBreakInside: 'avoid',
        },
      }}
    >
      <Box
        sx={{
          p: 1.5,
          display: 'flex',
          alignItems: 'center',
          bgcolor: '#e3f2fd',
          borderBottom: '1px solid #bbdefb',
          '@media print': {
            padding: '2mm',
            backgroundColor: '#e3f2fd !important',
            borderBottom: '0.1mm solid #bbdefb',
          },
        }}
      >
        <WaterDropIcon
          sx={{
            color: '#1976d2',
            mr: 1.5,
            '@media print': {
              marginRight: '1mm',
            },
          }}
        />
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'medium',
            color: '#0d47a1',
            '@media print': {
              fontSize: '3.5mm',
            },
          }}
        >
          {t('Irrigation Insight')}
        </Typography>
      </Box>

      <Box
        sx={{
          p: 2,
          bgcolor: 'white',
          '@media print': {
            padding: '2mm',
            backgroundColor: 'white !important',
          },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            lineHeight: 1.6,
            '@media print': {
              fontSize: '3mm',
              lineHeight: '4mm',
            },
          }}
        >
          {/* {getIrrigationMessage(insights, t)}*/}✅{' '}
          {t('No watering needed! Soil has adequate moisture.')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 1.5,
            pt: 1,
            borderTop: '1px dashed #e0e0e0',
            '@media print': {
              marginTop: '1mm',
              paddingTop: '1mm',
              borderTop: '0.1mm dashed #e0e0e0',
            },
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              '@media print': {
                fontSize: '2.5mm',
              },
            }}
          >
            {t('Based on satellite soil moisture data as on')}{' '}
            {new Date(date).toLocaleString()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default IrrigationInsightCard;
